import './styles.scss'
import React from 'react'
import UserTab from './UserTab'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { updateUserTabs } from '../../redux/actions/tabs'
// import UserTabInChat from './UserTabInChat'

function Index({ users, updateUserTabs, activeChannel }) {

  let isDragging = false
  let isDraggingOver = false

  const onDragStart = () => (isDragging = true)

  const onDragOver = (e) => {
    e.stopPropagation()
    e.preventDefault()
    isDraggingOver = true
  }

  const onDragEnd = (e) => {
    const user = e.target.dataset.user
    if (!user) return
  }

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)

    return result
  }

  const onDrop = (e) => {
    e.preventDefault()

    const user = e.target.dataset.user
    const activeUser = e.target.dataset.active
    const startIndex = users.findIndex((user) => user.id === activeUser)
    const endIndex = users.findIndex((u) => u.id === user)
    const usersReordered = reorder(users, startIndex, endIndex)

    updateUserTabs({ users: usersReordered, user: activeUser })
  }

  return (
    <div
      className='tabs'
      draggable='true'
      onDragStart={(e) => onDragStart(e)}
      onDragOver={(e) => onDragOver(e)}
      onDragEnd={(e) => onDragEnd(e)}
      onDrop={(e) => onDrop(e)}
    >
      {users.map((user) => (
        <UserTab user={user.id} key={user.id} isDragging={isDragging} isDraggingOver={isDraggingOver} channelTabs={user.channel} />
      ))}
    </div>
  )
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ updateUserTabs }, dispatch)
}

export default connect(null, mapDispatchToProps)(Index)
